const ids: Record<string, number> = {};
export function uniqueId(prefix = '') {
  if (!ids[prefix]) {
    ids[prefix] = 0;
  }

  return `${prefix ? `${prefix}_` : ''}${ids[prefix]++}`;
}
